module.exports = __webpack_public_path__ + "img/HZGB03-01-02.5efbea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB03-01-02.png
// module id = 9viw
// module chunks = 0